// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.y8hCh{padding:32px 24px 25px;display:flex;gap:36px}.y8hCh.zUMcV{flex-direction:column;gap:16px;padding:16px}.Df7O1{width:1px;background:#eaeaef}.zUMcV .Df7O1{display:none}.Y5bP_{flex:1;width:400px}.zUMcV .Y5bP_{width:100%;display:flex;flex-direction:column;gap:16px}.zUMcV .Y5bP_>*>:last-child{margin-bottom:0}.bGW4M{width:35%;min-width:415px;max-width:500px}.zUMcV .bGW4M{width:100%;min-width:unset;max-width:unset;display:flex;flex-direction:column;gap:16px}.zUMcV .bGW4M>*>:last-child{margin-bottom:0}.VNC4K{display:grid;grid-template-columns:1fr 1fr;gap:24px 8px;margin-bottom:32px}.VNC4K.chD03{margin-bottom:8px}.VNC4K.RJUYw{margin-bottom:24px}.zUMcV .VNC4K{grid-template-columns:1fr;gap:8px;margin-bottom:8px}.OOa0U{margin-bottom:24px}.zUMcV .OOa0U{margin-bottom:8px}.AyeFx{text-align:center;background:#f3f5ff}.ep2cW{display:flex;justify-content:space-between;align-items:center}.JDjUV{display:flex;align-items:center;gap:8px}.wSdS5{display:flex;flex-direction:column;gap:12px;margin-bottom:28px}.BBo2Z>*{flex:1}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"content": `y8hCh`,
	"mobile": `zUMcV`,
	"sep": `Df7O1`,
	"leftSection": `Y5bP_`,
	"rightSection": `bGW4M`,
	"topRightSection": `VNC4K`,
	"hasDiscountedPrice": `chD03`,
	"isBundle": `RJUYw`,
	"rowGap": `OOa0U`,
	"modalHeader": `AyeFx`,
	"modalFooter": `ep2cW`,
	"modalFooterEnd": `JDjUV`,
	"preapprovedSection": `wSdS5`,
	"equalWidthChildren": `BBo2Z`
};
export default ___CSS_LOADER_EXPORT___;
